import Global from "./Global";

export default {
  Global
};
